"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class RenewalCancellationReasonRequest {
}
exports.default = RenewalCancellationReasonRequest;
//# sourceMappingURL=RenewalCancellationReasonRequest.js.map